import { useAuth } from '@contexts/AuthContext';
import MaintenanceBanner from './Banners/MaintenanceBanner';
import SlackCommunityPopup from './SlackCommunityPopup';
import SlackChannelToast from './SlackChannelToast';
import DomainChangePopup from './DomainChangePopup';

const Announcements = () => {
  const { isInternalStaff } = useAuth();
  return (
    <>
      <MaintenanceBanner />
      {/* PostHog surveys: staff answers, masquerade included, would land on the customer's person. */}
      {!isInternalStaff && (
        <>
          <SlackCommunityPopup />
          <SlackChannelToast />
          <DomainChangePopup />
        </>
      )}
    </>
  );
};

export default Announcements;
